import {FormBuilder, FormGroup, Validators, ValidatorFn, AbstractControl} from '@angular/forms';
import {FormValidator} from "../validators/form.validator";

export class ForgotPasswordValidation {

  static createForgotPasswordForm(fb: FormBuilder): FormGroup {
    return fb.group({
      email: ['', [FormValidator.requiredField('Email is required.'), Validators.email, Validators.pattern(/^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/)]],
      new_password: ['', [FormValidator.requiredField('New password is required.'), Validators.minLength(8)]],
      confirm_password: ['', [FormValidator.requiredField('Confirm password is required.'), Validators.minLength(8), this._matchValidator('new_password')]],
    });
  }

  private static _matchValidator(matchTo: string): ValidatorFn {
    return (control: AbstractControl): { [key: string]: boolean } | null => {
      const parent = control.parent as FormGroup | null;
      const matchingControl = parent?.get(matchTo);
      if (matchingControl && control.value !== matchingControl.value) {
        return {'mismatch': true};
      }
      return null;
    };
  }
}
